import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./rootReducer";
import type { RootState } from "./types";

type CreateChatStoreParams = {
  preloadedState?: RootState;
};
export const createChatStore = ({
  preloadedState,
}: CreateChatStoreParams = {}) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export const store = createChatStore();
